import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from 'react-hook-form';

import PasswordInput from '../PasswordInput/PasswordInput';

type ControlledPasswordInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  id: TName;
  label: string;
  control: Control<TFieldValues>;
  autoComplete: 'current-password' | 'new-password';
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  errors?: FieldErrors<TFieldValues>;
};

export const ControlledPasswordInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  id,
  label,
  autoComplete,
  control,
  rules = {},
  errors,
}: ControlledPasswordInputProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <PasswordInput
          id={id}
          label={label}
          {...field}
          error={errors?.[id]?.message?.toString()}
          autoComplete={autoComplete}
        />
      )}
    />
  );
};
